export { default as ResourceLibrary } from "./ResourceLibrary.vue";
export { default as ResourceSearchResults } from "./ResourceSearchResults.vue";